import { getLocalAccessToken } from "../../../service/Token";


class CustomUploadAdapter {
    loader: any;
    xhr: XMLHttpRequest;
    constructor(loader: any) {
        this.loader = loader;
        this.xhr = new XMLHttpRequest();
    }

    upload() {
        return this.loader.file.then((file: any) => new Promise(((resolve, reject) => {
            this._initRequest();
            this._initListeners(resolve, reject, file);
            this._sendRequest(file);
        })))
    }

    _initRequest() {
        this.xhr.open('POST', `${process.env.REACT_APP_API_DOMAIN}/s3/upload`, true);
        this.xhr.responseType = 'text';
        const authorizationToken = `Bearer ${getLocalAccessToken()}`;
        this.xhr.setRequestHeader("Authorization", authorizationToken);
        this.xhr.withCredentials = true;
    }

    _initListeners(resolve: any, reject: any, file: any) {
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = '파일을 업로드 할 수 없습니다.'

        this.xhr.addEventListener('error', () => { reject(genericErrorText) })
        this.xhr.addEventListener('abort', () => reject())
        this.xhr.addEventListener('load', () => {
            const response = xhr.response
            if (!response || response.error) {
                return reject(response && response.error ? response.error.message : genericErrorText);
            }
            resolve({
                default: response //업로드된 파일 주소
            })
        })
    }

    _sendRequest(file: any) {
        const data = new FormData()
        data.append('multipartFile', file)
        this.xhr.send(data)
    }
}


export function HtmlCustomUploadAdapterPlugin(editor: any) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
        return new CustomUploadAdapter(loader)
    }
}